import { useEffect, useRef, useState } from "react";
import { RefreshCw } from "lucide-react";

const THRESHOLD = 70;

const setBodyTranslate = (y, animated = false) => {
  document.body.style.transition = animated ? "transform 0.2s ease" : "none";
  document.body.style.transform = y > 0 ? `translateY(${y}px)` : "";
};

const PullToRefresh = () => {
  const [pullDistance, setPullDistance] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const startYRef = useRef(null);
  const pullDistanceRef = useRef(0);

  useEffect(() => {
    const onTouchStart = (e) => {
      if (window.scrollY === 0) {
        startYRef.current = e.touches[0].clientY;
      }
    };

    const onTouchMove = (e) => {
      if (startYRef.current === null) return;
      const delta = e.touches[0].clientY - startYRef.current;
      if (delta > 0) {
        e.preventDefault();
        const dist = Math.min(delta * 0.5, THRESHOLD + 20);
        pullDistanceRef.current = dist;
        setPullDistance(dist);
        setBodyTranslate(dist);
      }
    };

    const doRefresh = () => {
      if (pullDistanceRef.current >= THRESHOLD) {
        setRefreshing(true);
        setBodyTranslate(0, true);
        pullDistanceRef.current = 0;
        setTimeout(() => {
          window.location.href = window.location.href;
        }, 400);
      } else {
        setBodyTranslate(0, true);
        pullDistanceRef.current = 0;
        setPullDistance(0);
      }
      startYRef.current = null;
    };

    window.addEventListener("touchstart", onTouchStart, { passive: true });
    window.addEventListener("touchmove", onTouchMove, { passive: false });
    window.addEventListener("touchend", doRefresh);
    window.addEventListener("touchcancel", doRefresh);

    return () => {
      window.removeEventListener("touchstart", onTouchStart);
      window.removeEventListener("touchmove", onTouchMove);
      window.removeEventListener("touchend", doRefresh);
      window.removeEventListener("touchcancel", doRefresh);
    };
  }, []);

  const visible = pullDistance > 10 || refreshing;
  const progress = Math.min(pullDistance / THRESHOLD, 1);

  if (!visible) return null;

  return (
    <div className="fixed top-3 left-0 right-0 z-50 flex justify-center pointer-events-none">
      <div className="bg-white rounded-full shadow-lg p-2.5 border border-border">
        <RefreshCw
          className="h-5 w-5"
          style={{
            color: "#FF2A6D",
            transform: `rotate(${refreshing ? 0 : progress * 360}deg)`,
            animation: refreshing ? "spin 0.6s linear infinite" : "none",
          }}
        />
      </div>
    </div>
  );
};

export default PullToRefresh;
